import React from "react";
import CompanyPeopleTab from "./CompanyPeopleTab";
import DealPeopleTab from "./DealPeopleTab";
import PartnerContacts from "@/pages/partners/contacts/PartnerContacts";

interface Props {
  entityId: string;
  companyId: string;
  dealId?: string | null;
  partnerId?: string | null;
}

const PeopleTab: React.FC<Props> = ({
  entityId,
  companyId,
  dealId,
  partnerId
}) => {
  if (partnerId) {
    return (
      <div className="flex flex-col h-full">
        <PartnerContacts key={partnerId} partnerId={partnerId} />
      </div>
    );
  }
  if (dealId) {
    return (
      <DealPeopleTab
        entityId={entityId}
        companyId={companyId}
        dealId={dealId}
      />
    );
  } else {
    return <CompanyPeopleTab companyId={companyId} />;
  }
};

export default PeopleTab;
